// extracted by mini-css-extract-plugin
export default {"intro":"Introduction_intro__ssSpa","icon":"Introduction_icon__GZnPF"};